/**
 * Zeus FAQ media — accordion + print swap (signature element).
 */
(function () {
  "use strict";

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initSection(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-zfm-item]"));
    if (!items.length) {
      return;
    }

    var print = root.querySelector("[data-zfm-print]");
    var panels = root.querySelectorAll("[data-zfm-panel]");
    var voice = root.querySelector("[data-zfm-voice]");
    var caption = root.querySelector("[data-zfm-caption]");

    function openItem(item) {
      items.forEach(function (it) {
        var on = it === item;
        it.classList.toggle("is-open", on);
        var btn = it.querySelector(".zeus-faq-media__q");
        if (btn) {
          btn.setAttribute("aria-expanded", on ? "true" : "false");
        }
      });

      var mediaId = item.getAttribute("data-media-id");
      panels.forEach(function (panel) {
        panel.classList.toggle("is-active", panel.getAttribute("data-media-id") === mediaId);
      });

      if (voice) {
        var tpl = item.querySelector("[data-zfm-voice-tpl]");
        voice.innerHTML = tpl ? tpl.innerHTML : "";
      }
      if (caption) {
        caption.textContent = item.getAttribute("data-fig") || "";
      }
      if (print && !prefersReducedMotion()) {
        print.classList.remove("is-settling");
        requestAnimationFrame(function () {
          print.classList.add("is-settling");
        });
      }
    }

    function closeItem(item) {
      item.classList.remove("is-open");
      var btn = item.querySelector(".zeus-faq-media__q");
      if (btn) {
        btn.setAttribute("aria-expanded", "false");
      }
    }

    items.forEach(function (item) {
      var btn = item.querySelector(".zeus-faq-media__q");
      if (!btn) {
        return;
      }
      btn.addEventListener("click", function () {
        if (item.classList.contains("is-open")) {
          closeItem(item);
          return;
        }
        openItem(item);
      });
    });

    var initial = root.querySelector("[data-zfm-item].is-open");
    if (initial) {
      openItem(initial);
    }
  }

  function boot() {
    document.querySelectorAll("[data-zeus-faq-media]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
